export const init = () => {
  checkoutSummaryCustomizations();
};

export const checkoutSummaryCustomizations = () => {
  const checkoutSummary = document.getElementById('v65-checkoutCartSummaryWrapper');
  const clubSummary = document.getElementById('v65-signUpClubSummaryWrapper');

  if (!checkoutSummary && !clubSummary) {
    return false;
  }

  const currentSummary = checkoutSummary || clubSummary;
  currentSummary.classList.add('checkout-summary');

  if (window.innerWidth < 768 || window.innerHeight < currentSummary.offsetHeight + 95) {
    currentSummary.removeAttribute('style');
    currentSummary.classList.remove('checkout-summary--sticky');
    return currentSummary;
  }

  const checkoutFooterHeight = document.getElementById('v65-checkoutFooter').offsetHeight;
  currentSummary.style.marginBottom = `${checkoutFooterHeight}px`;
  currentSummary.classList.add('checkout-summary--sticky');
  return currentSummary;
};



// WEBPACK FOOTER //
// ./src/assets/js/checkout.js